import * as React from 'react';
import { InputWithOptionsProps } from '../InputWithOptions';
import { DropdownLayoutValueOption } from '../DropdownLayout';

export interface SearchProps extends InputWithOptionsProps {
  expandable?: boolean;
  expandWidth?: string | number;
  predicate?: (option: DropdownLayoutValueOption) => boolean;
  debounceMs?: number;
}

export default class Search extends React.Component<SearchProps> {
  clear: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  blur: () => void;
  focus: () => void;
}
